import { configureStore } from '@reduxjs/toolkit';

import appReducer from './appSlice/appSlice';
import userReducer from './userSlice/userSlice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
